// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"160":"f0c3fc59","395":"48fd1d26","486":"eba37884","988":"3edea560"}[chunkId] + ".js";
};